/* eslint-disable */
console.log = function () {}
console.warn = function () {}
const bootstrapSelect = require('bootstrap-select');
import Swiper from 'swiper';

// bootstrapSelect
function animatedHover(containerSelector, itemSelector) {
	var activeItem = $('.' + containerSelector).find('.' + itemSelector + '.active');
	if ((($('.' + containerSelector).length) && $('.' + itemSelector).length) && (activeItem.length)) {
		var leftPos, newWidth, $magichover, newHeight;

		if (!$('.' + containerSelector).find('.magic-hover').length) {
			$('.' + containerSelector).append("<span class='magic-hover'></span>");

		}
		$magichover = $('.' + containerSelector).find('.magic-hover');
		$magichover.width(activeItem.innerWidth())
			.css({
				'left': activeItem.position().left,
				'height': activeItem.innerHeight()

			})
			.data('origLeft', activeItem.position().left)
			.data('origWidth', activeItem.innerWidth());


		$('.' + containerSelector).find('.' + itemSelector).hover(function () {
			var $thisElementBar = $(this);
			leftPos = $thisElementBar.position().left;
			newWidth = $thisElementBar.innerWidth();
			newHeight = $thisElementBar.innerHeight();


			if (!$('.' + containerSelector).hasClass('not-animated-hovered')) {
				console.log('hover')
				$magichover.css({
					"left": leftPos,
					"width": newWidth,
					"height": newHeight

				});
				activeItem.addClass('active-out');

			}
			// }
		}, function () {
			console.log('out');
			activeItem.removeClass('active-out');
			$magichover.css({
				"left": $magichover.data('origLeft'),
				"width": $magichover.data('origWidth'),
				"height": $magichover.data('origHeight')

			});
		});
	}

}
animatedHover('w-hover-tabs', 'nav-item')
window.onresize = function (event) {
	setTimeout(function () {
		animatedHover('w-hover-tabs', 'nav-item')

	}, 250);

};
window.pushUrlState = function (url) {
	window.history.pushState({
		path: url
	}, '', url);
}

function paginationInit() {
	setTimeout(function () {

		$('.s-slider  .w-one-slide').each(function () {
			var that = $(this);


			if (that.hasClass('pagination-on-imgs')) {
				that.find('.swiper-pagination');

				that.find('.swiper-pagination').css({
					"top": that.find('.swiper-slide-active .img').outerHeight() - 50,
					"bottom": "auto"
				});


			}



		})
	}, 50)
}
$(document).ready(() => {

	if ($('.joun-community').length > 0) {
		setTimeout(function () {
			$('.joun-community').addClass('show');

		}, 1500);
		$('.joun-community .close').click(function () {
			$('.joun-community').removeClass('show')
		})
	}
	paginationInit();


	if ($('.selectpicker').length) {
		$('.selectpicker').selectpicker();
	}


})
$(window).resize(function () {
	paginationInit();
});

$('.s-slider  .w-one-slide').each(function () {
	var that = $(this);
	let s_slider = new Swiper($(this), {
		spaceBetween: 20,

		slidesPerView: 1,

		preloadImages: false,
		// Enable lazy loading
		lazy: true,

		speed: 1200,

		lazy: true,
		speed: 1200,
		lazy: {
			loadPrevNext: true,
			loadPrevNextAmount: 1,
			loadOnTransitionStart: true,
		},
		// effect: 'fade',
		slidesPerView: 1,

		navigation: {
			nextEl: $(this).parent('.s-slider').find('.swiper-button-next'),
			prevEl: $(this).parent('.s-slider').find('.swiper-button-prev')
		},
		pagination: {
			el: $(this).parent('.s-slider').find('.swiper-pagination'),
			clickable: true,
			// dynamicBullets: true,
		},
	})


	paginationInit();
	var autoplay = that.attr('autoplay');


	if (typeof autoplay !== 'undefined' && autoplay !== false) {
		s_slider.autoplay.start();

	}

	//end //slideres
})

$('.testinmonials .slider').each(function () {
	var that = $(this);
	let s_slider = new Swiper($(this), {
		slidesPerView: 1,
		spaceBetween: 30,
		centeredSlides: true,
		slidesPerGroup: 1,
		breakpoints: {


			1024: {
				slidesPerView: 3,

			},
		},
		loop: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		lazy: true,
		speed: 1200,
		lazy: {
			loadPrevNext: true,
			loadPrevNextAmount: 1,
			loadOnTransitionStart: true,
		},
		navigation: {
			nextEl: $(this).parent('.testinmonials').find('.swiper-button-next'),
			prevEl: $(this).parent('.testinmonials').find('.swiper-button-prev')
		},
		pagination: {
			el: $(this).parent('.testinmonials').find('.swiper-pagination'),
			clickable: true,
			// dynamicBullets: true,
		},
	})
	var autoplay = that.attr('autoplay');


	if (typeof autoplay !== 'undefined' && autoplay !== false) {
		s_slider.autoplay.start();

	}

	//end //slideres
})

//
// var mySwiper = new Swiper('.coverflow-slider .swiper-container', {
// 	effect: 'coverflow',
// 	loop: true,
// 	centeredSlides: true,
// 	slidesPerView: 1,
// 	initialSlide: 1,
// 	mousewheelControl: true,
// 	autoplay: {
// 		delay: 3000,
// 	},
// 	lazyLoading: true,
// 	preventClicks: false,
// 	preventClicksPropagation: false,
// 	lazyLoadingInPrevNext: true,
// 	speed: 600,

// 	coverflowEffect: {
// 		rotate: 0,
// 		stretch: 0,
// 		depth: 900,
// 		modifier: 1,
// 		slideShadows: false,
// 	},
// 	breakpoints: {
// 		320: {
// 			slidesPerView: 2,
// 		},
// 		560: {
// 			slidesPerView: 2,
// 			coverflowEffect: {
// 				rotate: 0,
// 				stretch: 0,
// 				depth: 100,
// 				modifier: 1,
// 				slideShadows: false,
// 			},
// 		},
// 		990: {
// 			slidesPerView: 3,
// 			initialSlide: 2,

// 		}
// 	},


// 	// Navigation arrows
// navigation: {
// 	nextEl: '.coverflow-slider .swiper-button-next',
// 	prevEl: '.coverflow-slider .swiper-button-prev',
// },
// pagination: {
// 	el: $('.coverflow-slider').find('.swiper-pagination'),
// 	clickable: true,
// 	// dynamicBullets: true,
// },

// })


var mySwiper = new Swiper('.coverflow-slider .swiper-container', {
	effect: 'coverflow',
	loop: true,
	centeredSlides: true,
	slidesPerView: 2,
	initialSlide: 3,
	keyboardControl: true,
	mousewheelControl: true,
	lazyLoading: true,
	preventClicks: false,
	preventClicksPropagation: false,
	lazyLoadingInPrevNext: true,
	speed: 600,
	coverflowEffect: {
		scale: .85,
		rotate: 0,
		stretch: 20,
		depth: 300,
		modifier: 1,
		slideShadows: false,
	},
	autoplay: {
		delay: 3000,
	},
	breakpoints: {


		992: {
			slidesPerView: 4,
			coverflowEffect: {
				scale: .85,
				rotate: 10,
				stretch: 20,
				depth: 300,
				modifier: 1,
				slideShadows: false,
			},

		},
	},
	navigation: {
		nextEl: '.coverflow-slider .swiper-button-next',
		prevEl: '.coverflow-slider .swiper-button-prev',
	},
	pagination: {
		el: $('.coverflow-slider').find('.swiper-pagination'),
		clickable: true,
		// dynamicBullets: true,
	},

})
//mob menu toggle

$(".navbar-toggler ").click(function () {
	$(this).toggleClass('active');
	$('body').toggleClass('menu-toggle');

})
$(".close-menu").click(function () {
	$(".navbar-toggler").removeClass('active');
	$('body').removeClass('menu-toggle');

})

if ($('.board-members .member').length > 0) {
	//end mob menu
	let ActiveMemberItem;
	let that_member;
	$('.board-members .member').click(function () {
		ActiveMemberItem = $(this);
		that_member = $(this).data('id') - 1;

		$('.modal.members').modal('show');
		$('.modal.members').addClass('wait-load');



	})

	$('.modal.members').on('shown.bs.modal', function () {
		let members_slider = new Swiper($('.modal.members  .Slider'), {
			spaceBetween: 0,

			slidesPerView: 1,
			spaceBetween: 30,

			preloadImages: false,
			// Enable lazy loading
			lazy: true,
			autoHeight: true,
			speed: 500,
			initialSlide: that_member,
			lazy: {
				loadPrevNext: true,
				loadPrevNextAmount: 1,
				loadOnTransitionStart: true,
			},
			effect: 'fade',
			slidesPerView: 1,
			navigation: {
				nextEl: $('.modal.members').find('.swiper-button-next'),
				prevEl: $('.modal.members').find('.swiper-button-prev')
			},
			pagination: {
				el: $('.modal.members').find('.swiper-pagination'),
				clickable: true,
				// dynamicBullets: true,
			},
		})
		if (ActiveMemberItem.data('id') && !ActiveMemberItem.hasClass('stopPushState')) {
			let id = ActiveMemberItem.data('id');
			if (history.pushState) {
				window.pushUrlState('?' + modalItem + "=" + id)


			}
		}


		members_slider.on('slideChangeTransitionEnd', function (e) {
			let active = $('.modal.members  .Slider').find('.swiper-slide-active').index();
			let id = $('.board-members .member').eq(active).data('id');
			window.pushUrlState('?' + modalItem + "=" + id)

		});
		$('.modal.members').removeClass('wait-load');


		//members_slider.slideTo(parseInt(that_member), 0);





	})
}



if ($('input[type="file"]').length > 0) {
	$('input[type="file"]').change(function (e) {
		var fileName = e.target.files[0].name;
		$(this).parent().find('.custom-file-label').html(fileName);
	})
}


//search input
//https://bbbootstrap.com/snippets/expandable-search-bar-12368750
$(document).ready(function () {
	var submitIcon = $('.searchbar-icon');
	var inputBox = $('.searchbar-input');
	var searchbar = $('.searchbar');
	var isOpen = false;
	submitIcon.click(function () {
		if (isOpen == false) {
			searchbar.addClass('searchbar-open');
			inputBox.focus();
			isOpen = true;
		} else {
			searchbar.removeClass('searchbar-open');
			inputBox.focusout();
			isOpen = false;
		}
	});
	submitIcon.mouseup(function () {
		return false;
	});
	searchbar.mouseup(function () {
		return false;
	});
	$(document).mouseup(function () {
		if (isOpen == true) {
			$('.searchbar-icon').css('display', 'block');
			submitIcon.click();
		}
	});
});

function buttonUp() {
	var inputVal = $('.searchbar-input').val();
	inputVal = $.trim(inputVal).length;
	if (inputVal !== 0) {
		$('.searchbar-icon').css('display', 'none');
	} else {
		$('.searchbar-input').val('');
		$('.searchbar-icon').css('display', 'block');
	}
}
